import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TemporallyResetPasswordPage } from './temporally-reset-password.page';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.temporallyResetPassword.pageInRouting,
    component: TemporallyResetPasswordPage,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('../temporally-reset-password/temporally-reset-password.module').then( m => m.TemporallyResetPasswordPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TemporallyResetPasswordPageRoutingModule {}
